module.exports = __webpack_public_path__ + "img/5.8b67e28b.png";